<!DOCTYPE html>
<head>
<meta name="viewport" content="width=device-width, initial-scale=1">
</head>
<ng-container *ngIf="user">
  <app-toolbar [user]="user" [title]="title" [back]="true" [destination]="destination"></app-toolbar>
</ng-container>

<mat-card>
    <mat-card-title style="font-weight:bold;color:#009687">Inserisci un nuovo avviso</mat-card-title>
    <mat-card-subtitle>Scrivi il testo dell'avviso. Verrà mandato a tutti i pazienti della piattaforma.</mat-card-subtitle>
    <mat-card-content>
        <mat-card class="mat-elevation-z10">
                <mat-form-field class="myTextFieldMobile">
                  <mat-label>Testo</mat-label>
                  <textarea [(ngModel)]="textSend" matInput></textarea>
                </mat-form-field>
        </mat-card>
          </mat-card-content>
          <mat-card-actions style="text-align: center;">
          <button mat-raised-button color="primary" aria-label="Invia il messaggio" [disabled]="textSend === ''" (click)="sendAnnouncement()">
            INVIA
          </button>
    </mat-card-actions>
</mat-card>

<mat-divider></mat-divider>
<mat-divider></mat-divider>


<mat-card>
  <mat-card-content>
    <mat-card-title style="font-weight:bold;color:#009687">Ultimi avvisi:</mat-card-title>
    <div *ngIf="!announcements"><h2>Nessun avviso pubblicato.</h2></div>
      <ng-container *ngFor="let ann of announcements; index as i">
      <ng-container *ngIf="i==0">
        <mat-card id="element-announcements">
          <mat-card-title id="title-announcement-first">Dal dott. {{ann.doctorName}} {{ann.doctorSurname}}</mat-card-title>
          <mat-card-subtitle style="color:black">Data : {{ann.giorno}}-{{ann.mese}}-{{ann.anno}}</mat-card-subtitle>
          <mat-card-content>
              {{ann.text}}
          </mat-card-content></mat-card>

      </ng-container>
      <ng-container *ngIf="i!=0">
        <ng-container *ngIf="i==1"><h3>Vecchi avvisi:</h3></ng-container>
        <mat-card class="element-announcements">
          <mat-card-title>Dal dott. {{ann.doctorName}} {{ann.doctorSurname}}</mat-card-title>
          <mat-card-subtitle>Data : {{ann.giorno}}-{{ann.mese}}-{{ann.anno}}</mat-card-subtitle>
          <mat-card-content>
              {{ann.text}}
          </mat-card-content></mat-card>

      </ng-container>
    
              
          </ng-container>
      </mat-card-content>
    </mat-card>
    


  